const baseUrls = {
    dev: 'https://psta-agentfun-service.crorc.co',
    sta: 'https://psta-agentfun-service.crorc.co',
    prod: 'https://api.agentfun.ai',
    uat: 'https://api.agentfun.ai',
};
export const getServerEndpoint = (endpoint) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const appEnv = process.env.APP_ENV ?? '';
    if (!baseUrls[appEnv]) {
        throw new Error(`Unknown or missing APP_ENV: ${appEnv}`);
    }
    return `${baseUrls[appEnv]}/${endpoint}`;
};
